import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		receives: [],
		receivesStatics: {
			averagePurchases: 0,
			sumPurchases: 0,
			sumWeightsOfPurchases: 0,
		},
	},

	actions: {
		fetchAll({ commit }, { date, status, providerId, orderByDate, orderByWeight, page, perPage, ownerIds, usePagination }) {
			const params = { date, status, providerId, orderByDate, orderByWeight, page, perPage, usePagination };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				// if (params[key]) urlSearchParams.append(key, params[key]);
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key])
			});
			urlSearchParams.append('sortByCreatedAt', true)
			urlSearchParams.append('nonDeleted', true)
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/receives', { params: urlSearchParams })
		},

		fetchById({ commit }, { id, IsPurchase }) {
			return axios.get(`/receives/${id}`);
		},

		fetchReceivesStatics({ commit }, { providerId, date, status, ownerIds }) {
			const params = { providerId, date, status };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				if (params[key]) urlSearchParams.append(key, params[key]);
			});
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/receives/purchaseStatics', { params: urlSearchParams }).then(data => {
				commit(types.STORE_RECEIVES_STATICS, data);
				return data;
			})
		},

		fetchReport({ commit }, { date, lot, page, perPage, ownerIds, usePagination }) {
			const params = { date, lot, page, perPage, usePagination };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				// if (params[key]) urlSearchParams.append(key, params[key]);
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key])
			});
			urlSearchParams.append('sortByCreatedAt', true)
			urlSearchParams.append('nonDeleted', true)
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/receives/report', {
				params: urlSearchParams
			})
		},

		create({ commit }, { purchaseId, lot, date, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note }) {
			return axios.post('/receives', { purchaseId, lot, date, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note })
		},

		update({ commit }, { id, purchaseId, lot, date, ownerId, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note, items, humidity, excludeFromStatistics }) {
			return axios.put(`/receives/${id}`, { purchaseId, lot, date, ownerId, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note, items, humidity, excludeFromStatistics })
		},

		delete({ commit }, { id }) {
			return axios.delete(`/receives/${id}`)
		},

		fetchStatisticsTotal({ commit }, { date, status, lot, ownerIds, usePagination }) {
			const params = { date, status, lot, usePagination };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				// if (params[key]) urlSearchParams.append(key, params[key]);
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key])
			});
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/receives/report/summary', { params: urlSearchParams }).then(data => {
				return data;
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_RECEIVES_STATICS](state, statics) {
			state.receivesStatics.averagePurchases = statics.averagePurchases;
			state.receivesStatics.sumPurchases = statics.sumPurchases;
			state.receivesStatics.sumWeightsOfPurchases = statics.sumWeightsOfPurchases;
		},

		[types.RESET](state, statics) {
			state.receivesStatics.averagePurchases = 0;
			state.receivesStatics.sumPurchases = 0;
			state.receivesStatics.sumWeightsOfPurchases = 0;
		}
	}
}